(function() {
  const callback = () => {
    if(document.querySelector(`.pumper__quantity_label1`)) {
      pumperObserver.disconnect();

      if (window.pumperTextTranslation.length > 0) {
        window.pumperTextTranslation.forEach((block, index) => {
          const pumperBlock = document.querySelector(`#pumper__label_${index + 1}`);

          if (pumperBlock) {
            const pumperTextBlock = pumperBlock.querySelector('.pumper_horizontal_offer_subtitle_wrapper .pumper_horizontal_offer_subtitle');
            const pumperTitleWrapper = pumperBlock.querySelector('.pumper_horizontal_title_wrapper');

            if (pumperTextBlock) {
              pumperTextBlock.removeAttribute('data-tier-offer-subtitle');
              pumperTextBlock.innerText = block;
            } else if (pumperTitleWrapper) {
              pumperTitleWrapper.insertAdjacentHTML('afterend', `<div class="pumper_horizontal_offer_subtitle_wrapper"><div class="pumper_horizontal_offer_subtitle">${block}</div></div>`);
            }
          }
        });
      }
    }
  }

  const pumperObserver = new MutationObserver(callback);
  const target = document.querySelector('#svelte-bundle-widget');

  pumperObserver.observe(target, {childList: true, subtree: true});
})();
